export class BankAccountTypes {
  static CHECKING = 'CHECKING'
  static SAVINGS = 'SAVINGS'
}
